export enum ChatStatus {
    None = 0,
    Open = 1,
    Closed = 2,
}
